import { USE_MOCKS } from '../config/serviceConfig';
import { adminMock } from './mock/admin.mock';
import { adminReal } from './real/admin.real';

export const adminService = USE_MOCKS ? adminMock : adminReal;
